import React from 'react';
import './heading-layout.scss';

export type HeadingLayoutProps = {
  renderMainHeading: () => React.ReactFragment;
  renderSubHeading?: () => React.ReactFragment;
};

export function HeadingLayout(props: HeadingLayoutProps) {
  return (
    <section className="HeadingLayout">
      <section className={`main-heading${props.renderSubHeading ? ' with-sub-heading' : ''}`}>
        {props.renderMainHeading()}
      </section>

      {props.renderSubHeading && (
        <section className="sub-heading">{props.renderSubHeading()}</section>
      )}
    </section>
  );
}
